import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { backTarget } from "../lib/backNavigation";
import { backButton } from "../lib/telegram";

/**
 * useTelegramBackButton связывает нативную кнопку Telegram с навигацией витрины
 * (docs/07-miniapp-ux.md §1.2).
 *
 * Хук один на всё приложение и живёт в ShopGuard: куда вести с каждого экрана,
 * решает таблица в lib/backNavigation, а не сами страницы. Иначе семь экранов
 * заводили бы семь почти одинаковых эффектов, и забытый на новом экране вызов
 * оставил бы кнопку от предыдущего — она ведёт не туда и выглядит как поломка.
 */
export function useTelegramBackButton(): void {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const target = backTarget(pathname);

  useEffect(() => {
    if (target === null) {
      backButton.hide();
      return;
    }

    backButton.show();
    const off = backButton.onClick(() => navigate(target));
    return () => {
      // Обработчик снимается вместе с экраном: Telegram хранит его у себя,
      // и без снятия кнопка на следующем экране уводила бы на предыдущий адрес.
      off();
    };
  }, [target, navigate]);
}
